import register from '../util/init'
import { debounce } from './tools'

function onSortFilterChange (e) {
  const advisersList = document.querySelector('.advisers__list')
  const filtersSearch = document.querySelector('.filters__search')
  const filtersSort = document.querySelector('.filters__sort')

  let value = filtersSearch.value
  if (filtersSearch.value === '' || filtersSearch.value === '%20') {
    value = 'all'
  }

  window
    .fetch(value + '/' + filtersSort.value, {
      headers: {
        Accept: 'application/json'
      },
      credentials: 'include'
    })
    .then(response => {
      return response.json()
    })
    .then(JsonResponse => {
      if (e.target.value === 'all') {
        advisersList.innerHTML = ''
      } else {
        advisersList.innerHTML = JsonResponse.advisers_template
      }
    })
}

function advisers (container) {
  const sortFilter = document.querySelector('.filters__sort')
  const portfoliosSearch = document.querySelector('.filters__search')

  sortFilter.addEventListener('change', e => onSortFilterChange(e))
  portfoliosSearch.addEventListener(
    'keyup',
    debounce(e => onSortFilterChange(e), 300)
  )
}

register('.advisers', advisers)



// WEBPACK FOOTER //
// ./assets/j/src/advisers.js